<template>
    <q-card flat>
        <q-card-section class="text-black no-padding">
            <q-item class="q-pa-none">
                <q-item-section class="text-h6">{{recipientName}}</q-item-section>
            </q-item>
        </q-card-section>

        <q-card-section class="no-padding bank-account">
            <q-list class="rounded-borders">
                <q-item class="q-pa-none">
                    <q-item-section>
                        <q-item-label>{{ paymentMethod }}</q-item-label>
                        <q-item-label v-if="bankName">{{ bankName }}</q-item-label>
                        <q-item-label v-if="accountNumber">{{accountNumber}}</q-item-label>
                        <q-item-label v-if="notes">{{notes}}</q-item-label>
                    </q-item-section>
                </q-item>
            </q-list>
        </q-card-section>
    </q-card>
</template>

<script>
export default {
    name: "RecipientStickyNote",
    props: {
        recipientName: {
            type: String,
            required: true
        },
        paymentMethod: {
            type: String,
            required: true
        },
        bankName: {
            type: String,
            required: false
        },
        label1: {
            type: String,
            required: true
        },
        accountNumber: {
            type: String,
            required: true
        },
        label2: {
            type: String,
            required: false
        },
        notes: {
            type: String,
            required: false
        },
    },
    data() {
        return {}
    },
    methods: {},
}
</script>

<style scoped>
    .bank-account .q-item__label {
        padding-top: 7px;
        padding-bottom: 7px;
    }
</style>
